"use client";

const perks = [
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#grad-growth)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad-growth" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#d946ef" />
          </linearGradient>
        </defs>
        <rect x="3" y="14" width="2.5" height="7" rx="0.5" />
        <rect x="8" y="11" width="2.5" height="10" rx="0.5" />
        <rect x="13" y="7" width="2.5" height="14" rx="0.5" />
        <path d="M3 9l6-5 6 4 6-6" />
        <path d="M17 2h4v4" />
      </svg>
    ),
    title: "Growth Mindset",
    description: "Learn, unlearn and level up every day.",
  },
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#grad-balance)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad-balance" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#d946ef" />
          </linearGradient>
        </defs>
        <path d="m16 16 3-8 3 8c-.1.3-.3.5-.6.5h-4.8c-.3 0-.5-.2-.6-.5Z" />
        <path d="m2 16 3-8 3 8c-.1.3-.3.5-.6.5H3c-.3 0-.5-.2-.6-.5Z" />
        <path d="M12 3v17" />
        <path d="M3 6h18" />
        <path d="M12 20h3" />
        <path d="M12 20H9" />
      </svg>
    ),
    title: "Work–Life Balance",
    description: "Flexible schedules & remote-first culture.",
  },
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#grad-culture)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad-culture" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#d946ef" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="8" r="3.5" />
        <path d="M6 19c0-3 3-5 6-5s6 2 6 5" />
        <circle cx="6" cy="10" r="2.5" />
        <path d="M2 20c0-2 2-3.5 4-3.5" />
        <circle cx="18" cy="10" r="2.5" />
        <path d="M18 16.5c2 0 4 1.5 4 3.5" />
      </svg>
    ),
    title: "Open Culture",
    description: "Ideas welcome, Egos not invited.",
  },
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#grad-fun)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad-fun" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#d946ef" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <circle cx="9" cy="9" r="1" fill="url(#grad-fun)" />
        <circle cx="15" cy="9" r="1" fill="url(#grad-fun)" />
      </svg>
    ),
    title: "Fun First",
    description: "From gaming nights to weekend getaways.",
  },
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#grad-ownership)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad-ownership" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#d946ef" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" fill="url(#grad-ownership)" />
      </svg>
    ),
    title: "Ownership",
    description: "Real impact. Real responsibility.",
  },
];

export default function WhyTachonauts() {
  return (
    <section className="w-full border-t border-b border-border-primary py-10! px-6! md:px-12!  2xl:px-24! flex flex-col lg:flex-row items-start justify-between gap-12 lg:gap-16 2xl:gap-24 bg-transparent box-border font-sans">
      <div className="w-full lg:w-[280px] xl:w-[320px] 2xl:w-[380px] shrink-0 flex flex-col gap-3 2xl:gap-4">
        <span className="text-xs 2xl:text-sm font-bold tracking-[0.1em] uppercase bg-gradient-to-r from-[#6366f1] to-[#d946ef] bg-clip-text text-transparent inline-block">
          WHY TACHONAUTS LOVE IT HERE
        </span>
        <h2 className="text-text-primary text-3xl md:text-[30px] 2xl:text-[36px] font-bold leading-[1.2] m-0">
          More than a job.
          <br />
          It's a journey.
        </h2>
      </div>

      <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 sm:gap-10 lg:gap-6 2xl:gap-10 w-full">
        {perks.map((perk, i) => (
          <div key={i} className="flex flex-col items-center text-center gap-4 group">
            <div className="w-14 h-14 flex items-center justify-center mb-1! transition-transform duration-300 group-hover:scale-110">{perk.icon}</div>

            <div className="flex flex-col gap-2">
              <p className="text-text-primary text-base md:text-[17px] 2xl:text-[19px] font-semibold m-0 tracking-wide">{perk.title}</p>
              <p className="text-text-secondary text-xs md:text-[13px] 2xl:text-[15px] leading-relaxed m-0! max-w-[180px] 2xl:max-w-[200px] mx-auto!">{perk.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
